export const FOLDERS = 1;
export const SEQUENCES = 2;
